import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import InterviewPipeline from "./InterviewPipeline";
import ScheduleInterviewPage from "../Candidates/ScheduleInterviewPage";
import "./Interviews.scss";

const INTERVIEW_TABS = [
  {
    id: "pipeline",
    label: "Interview Pipeline",
    path: "/recruitment/interviews/pipeline",
  },
  {
    id: "schedule",
    label: "Schedule Interview",
    path: "/recruitment/interviews/schedule",
  },
];

const InterviewsPage = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { hasRole } = useAuth();
  const isRecruiterHR = hasRole("ROLE_RECRUITER-HR");
  const tabs = isRecruiterHR
    ? INTERVIEW_TABS
    : INTERVIEW_TABS.filter((tab) => tab.id === "pipeline");
  const requestedTab = pathname.endsWith("/schedule") ? "schedule" : "pipeline";
  const activeTab = tabs.some((tab) => tab.id === requestedTab)
    ? requestedTab
    : "pipeline";

  React.useEffect(() => {
    if (requestedTab !== activeTab) {
      navigate("/recruitment/interviews/pipeline", { replace: true });
    }
  }, [activeTab, navigate, requestedTab]);

  return (
    <div className="interviews-page">
      <div className="interviews-tabs" role="tablist" aria-label="Interviews">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={activeTab === tab.id}
            className={`interviews-tab${activeTab === tab.id ? " interviews-tab--active" : ""}`}
            onClick={() => navigate(tab.path)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === "pipeline" ? (
        <InterviewPipeline />
      ) : (
        <ScheduleInterviewPage />
      )}
    </div>
  );
};

export default InterviewsPage;
